import React from 'react'
import { Grid, PageHeader, PageSection as Section } from '@superhi/design'

import { Wrapper } from '../styles'
import { Props } from '../data'

import Main from 'src/components/Main'
import Page from 'src/components/Page'
import ContentfulRichTextBody from 'src/components/ContentfulRichTextBody'
import SEO from 'src/components/SEO'

const GRID_1_CELL_SPAN_1: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: [2, 7],
  large: [3, 10],
}

const Generic: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  seoDescription,
  seoImage,
  body,
}) => (
  <Page>
    <SEO
      // title={page.seoTitle || page.title}
      title={title}
      description={seoDescription || undefined}
      imageUrl={seoImage?.url || undefined}
    />

    <Main>
      <PageHeader title={title} backgroundVersion="PINK_01" />

      <Section>
        <Grid>
          <Grid.Cell span={GRID_1_CELL_SPAN_1}>
            <Wrapper>
              <ContentfulRichTextBody>{body}</ContentfulRichTextBody>
            </Wrapper>
          </Grid.Cell>
        </Grid>
      </Section>
    </Main>
  </Page>
)

export default Generic
